<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <div class="row">
          <!--Form-->
          <div class="card col-xs-12 col-md-7 card-custom mb-5 pl-0 pr-0">
            <b-card>
              <template #header>
                <h4 class="mb-0">NAAC Sales Book</h4>
              </template>
              <div class="row">
                <div class="col">
                  <div>
                    <b-form-group label="Start Date" label-for="startdate">
                      <b-input-group>
                        <b-form-input
                          v-model="form.startdate"
                          :state="validateState('startdate')"
                          name="startdate"
                          type="text"
                          autocomplete="off"
                          v-mask="'####-##-##'"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          placeholder="YYYY-MM-DD"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            v-model="form.startdate"
                            :state="validateState('startdate')"
                            class="button-only-datepicker"
                            name="startdate"
                            size="sm"
                            button-only
                            right
                            locale="en-US"
                          ></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback>
                          Start Date is required.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="col">
                  <div>
                    <b-form-group label="End Date" label-for="enddate">
                      <b-input-group>
                        <b-form-input
                          v-model="form.enddate"
                          :state="validateState('enddate')"
                          name="enddate"
                          type="text"
                          autocomplete="off"
                          v-mask="'####-##-##'"
                          class="form-control form-control-solid h-auto py-3 px-3"
                          placeholder="YYYY-MM-DD"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            v-model="form.enddate"
                            :state="validateState('enddate')"
                            class="button-only-datepicker"
                            name="enddate"
                            size="sm"
                            button-only
                            right
                            locale="en-US"
                          ></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback>
                          End Date is required.
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="row text-left">
                <div class="col-12">
                  <button 
                    ref="submit"
                    :disabled="$v.$invalid || !$v.$anyDirty"
                    type="button"
                    class="btn btn-primary py-2 p-x2 mx-1"
                    @click="viewReport"
                  >
                    View Report
                  </button>
                </div>
              </div>
            </b-card>
          </div>
          <!--End of Form-->
      </div>
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CommonService from "@/core/services/common.service";
import moment from "moment";
import ApiService from "@/view/pages/easyreceipt/api";

export default {
  components: {},
  mixins: [validationMixin],
  directives: { mask },
  data() {
    return {
      form : {
        startdate : moment(new Date()).format('YYYY-MM-DD'),
        enddate : moment(new Date()).format('YYYY-MM-DD')
      }  
    }
  },
  validations: {
    form: {
      startdate: { required,
        isDateValid : (value) => {
          return CommonService.isDateValid(value);
        }
      },
      enddate: { required,
        isDateValid : (value) => {
          return CommonService.isDateValid(value);
        }
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser", "currentUserProfile"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    },
    globalTaxtType() {
      return (this.currentUserProfile && this.currentUserProfile.TaxType == "VAT")? "Vatable" : "";
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Sales Summary");
      this.$v.form.$touch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    viewReport(){
      const startdate = new Date(this.form.startdate).toISOString();
      const enddate = new Date(this.form.enddate).toISOString();
      const TIN = this.currentUserProfile.TIN;
      const url = `https://${ApiService.getReportHost()}/reportserver/reportserver/httpauthexport?key=BIR_NAAC_BY_TIN${ApiService.testEnvironmentReportsKeySuffix()}&p_RP_TIN=${TIN}&p_RP_TransactionStartDate=${startdate}&p_RP_TransactionEndDate=${enddate}&user=EasyReceiptRO&apikey=79PKXGScP8r8&format=pdf&download=false`
      window.open(url, '_blank').focus();
    }
  }
};
</script>
